// ---------------------------------------------------------------------------
// Betreiberangaben von Avliana — eine Quelle für Impressum und
// Datenschutzerklärung.
//
// SPIEGEL: Diese Datei liegt byte-gleich unter mobile/lib/firma.js (die App
// kann nicht aus frontend/ importieren); die Mailfuß-Fassung steht in
// backend/config/firma.py. scripts/check-rechtstexte-spiegel.mjs hält Web und
// App in der CI gleich. Wer hier etwas einträgt, trägt es in allen drei ein.
//
// Seit 30.09.2026 ist der Betreiber ein EINZELUNTERNEHMEN in Deutschland,
// keine zypriotische Ltd. — Begründung und Ausfüllanleitung im Kopf von
// backend/config/firma.py.
//
// Bis zum 12.08.2026 standen im Web „Limassol" und die erfundene Nummer
// „+357 25 000 000" fest im Markup, in der App bis zum 30.09.2026. Eine
// erfundene Angabe sieht auf einer Impressumsseite geprüft aus und wird nie
// nachgetragen. Deshalb bleibt Unbekanntes hier leer und erscheint auf der
// Seite als sichtbare Lücke.
// ---------------------------------------------------------------------------

// Anschrift NUR fürs Impressum, nie im Footer (Nics Vorgabe: so wenig
// sichtbar, wie das Gesetz erlaubt). Keine Telefonnummer, bewusst kein Feld
// dafür — die zweite Kontaktmöglichkeit nach § 5 DDG ist das Kontaktformular.
export const FIRMA = {
  name: "Avliana",                 // Geschäftsbezeichnung
  inhaber: "Niclas Erichreineke",  // der eigentliche Unternehmer
  rechtsform: "Einzelunternehmen",
  anschrift: ["Stauffenbergstraße 9", "96215 Lichtenfels"],
  land: "Deutschland",
  ustId: "",                       // USt-IdNr., Form "DE123456789" — beantragt 30.09.2026
  email: "contact@avliana.com",
};

/** „Avliana · Niclas Erichreineke" — Geschäftsbezeichnung plus Inhaber. */
export function vollstaendigerName() {
  return [FIRMA.name, FIRMA.inhaber].filter(Boolean).join(" · ").trim();
}

export default FIRMA;
